// duration.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

type Unit = 'ms' | 's';

@Pipe({
  name: 'msDuration',
  standalone: true,
})
export class MsDurationPipe implements PipeTransform {

  /**
   * @param value   Milisegundos o segundos, según `unit`
   * @param unit    'ms' (por defecto) o 's'
   * @param showZeros  si false, oculta días/horas/min/seg con valor 0
   * @param compact    si true, corta los sufijos a 1 letra ('d','h','m','s')
   */
  transform(
    value: number | null | undefined,
    unit: Unit = 'ms',
    showZeros = true,
    compact = false
  ): string {

    if (value == null || isNaN(value)) return '–';

    // normalizamos a segundos
    const totalSeconds = unit === 'ms'
      ? Math.floor(value / 1000)
      : Math.floor(value);

    const days    = Math.floor(totalSeconds / 86_400);
    const hours   = Math.floor((totalSeconds % 86_400) / 3_600);
    const minutes = Math.floor((totalSeconds % 3_600)  / 60);
    const seconds =  totalSeconds % 60;

    const parts: [number, string][] = [
      [days,    compact ? 'd' : 'd'],
      [hours,   compact ? 'h' : 'h'],
      [minutes, compact ? 'm' : 'm'],
      [seconds, compact ? 's' : 's'],
    ];

    return parts
      .filter(([n]) => showZeros ? true : n !== 0)
      .map(([n, suf]) => `${n} ${suf}`)
      .join(' ')
      .trim();
  }
}
